// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2405":"bf3b217b7955ee0e","2888":"22e9cb4d1c02f0fd"}[chunkId] + ".css";
};